module.exports = __webpack_public_path__ + "img/mastodon.png";